import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllTicket } from "../api/ticketApi";
import { Constants } from "../lib/const/constants";

export default function Verify2FA() {
    const location = useLocation();
    const navigate = useNavigate();
    const { qr, qrEnabled, userId, workspace, staff_login_node } = location.state || {};

    

    const [otp, setOtp] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    if (!qr) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F4F7FE]">
                <p className="text-gray-600 text-lg font-medium">
                    Missing verification details. Please login again.
                </p>
            </div>
        );
    }

    const handleVerify = async (e) => {
        e.preventDefault();
        setError(null);

        if (otp.trim().length !== 6) {
            setError("Please enter a valid 6-digit code.");
            return;
        }
        setLoading(true);
        try {
            await axios.post(
                Constants.BASE_URL + "API-FX-245-VALIDATE-LOGIN-QR-OTP",
                {
                    email: qr.email,
                    token: otp,
                    userId: userId,
                    workspaceId: workspace
                },
                {
                    headers: {
                        'fx_key': Constants.SUBSCRIPTION_KEY,
                        'Content-Type': 'application/json',
                    },
                    auth: {
                        username: Constants.REPORTS_USER_NAME,
                        password: Constants.REPORTS_PASSWORD,
                    },
                }
            ).then(resp => {
                console.log(resp.data);
                setAsyncData('qr_login_completed', '1')
                if(staff_login_node === 'STAFF_LOGIN'){
                    setLoading(false);
                    setAsyncData('qr_enabled', 1);
                    navigate("/DebitTransactions", { state: { qr_login_completed: 1 } });
                }else{
                getTicketsData();
                }
            }).catch(err => {
                setError(err.response.data.response);
                setLoading(false);
            })
        } catch (err) {
            console.error("2FA verify error:", err);
            setError("Verification failed. Please try again later.");
            setLoading(false);
        }
    };
    const setAsyncData = async (key, value) => {
        sessionStorage.setItem(key, value);
    }
    const getTicketsData = async () => {
        const data = await getAllTicket(qr.user_id);
        const backendIdsAtLogin = (data.results || [])
            .filter((ticket) => ticket.assign_to !== null)
            .map((ticket) => ticket.id);
        localStorage.setItem(
            "backendTicketIdsAtLogin",
            JSON.stringify(backendIdsAtLogin)
        );
        setLoading(false);
        setAsyncData('qr_enabled', 1)
        navigate("/", { state: { qr_login_completed: 1 } });

    }
    return (
        <div
            className="min-h-screen flex items-center justify-center px-4"
            style={{
                background: "linear-gradient(135deg, #0B214E 0%, #1E3A8A 50%, #F2630B 100%)",
            }}
        >
            <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6 sm:p-8 text-center">
                {/* Logo */}
                <div className="flex justify-center mb-5">
                    <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-40 sm:w-48" />
                </div>

                <h2 className="text-xl sm:text-2xl font-semibold text-[#0B214E] mb-2">
                    Two-Factor Authentication
                </h2>
                {qrEnabled == 0 &&
                    <>
                        <p className="text-gray-600 mb-5 text-sm sm:text-base">
                            Scan the QR code using <b>Google Authenticator</b> or <b>Microsoft Authenticator</b> and enter the 6-digit code below.
                        </p>

                        {/* QR Code */}
                        <div className="flex justify-center mb-6">
                            <img
                                src={qr.qr_code_base64}
                                alt="2FA QR Code"
                                className="w-52 h-52 sm:w-56 sm:h-56 object-contain border border-gray-300 p-2 rounded-lg shadow-sm"
                            />
                        </div>
                    </>
                }

                <form onSubmit={handleVerify}>
                    <input
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        placeholder="Enter 6 digit code"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                        className="w-full p-3 border border-gray-300 rounded-md outline-none text-center tracking-widest text-lg font-medium focus:ring-2 focus:ring-[#F2630B] mb-3"
                    />
                    {error && (
                        <div className="text-red-500 text-sm mb-3">{error}</div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-2 sm:py-3 rounded-md text-white font-semibold transition ${loading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-[#F2630B] hover:bg-[#d35609]"
                            }`}
                    >
                        {loading ? "Verifying..." : "Verify & Continue"}
                    </button>
                </form>

                {/* Secret fallback */}
                {qrEnabled == 0 &&
                    <div className="mt-5 text-gray-500 text-sm">
                        If you can’t scan QR, use this code:
                        <div className="font-mono text-sm text-[#0B214E] mt-1 bg-gray-100 py-1 px-2 rounded-md inline-block">
                            {qr.secret}
                        </div>
                    </div>
                }

                {qrEnabled != 0 &&
                    <div className="mt-5 text-gray-500 text-sm">
                        Enter the verification code from your authenticator app
                        {/* <div className="font-mono text-sm text-[#0B214E] mt-1 bg-gray-100 py-1 px-2 rounded-md inline-block">
                            If you experience any issues with authentication, please contact our support team(support@fxmaster.co.uk).
                        </div> */}
                    </div>
                }

                <p className="mt-6 text-xs text-gray-400">
                    If you experience any issues with authentication, please contact our support team (support@fxmaster.co.uk).
                </p>
            </div>
        </div>
    );
}